import { useDialog } from "@apac/hooks";
import { useModuleBEM } from "@b2bportal/core-themes";
import { AlgomerchTag } from "@b2bportal/core-types";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@b2bportal/core-ui/overridable";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { HSBCAlgomerchTag } from "@hsbc/types";
import { AlgomerchTags } from "@tenant/flights";
import styles from "./styles.module.scss";
// Remove BestQuality from everywhere as they could be misleading sometimes
const tagToDescription: Record<HSBCAlgomerchTag, string> = {
  [AlgomerchTag.Cheapest]: "flightScore.tags.cheapest",
  [AlgomerchTag.BestFlight]: "flightScore.tags.bestFlight",
  [AlgomerchTag.Fastest]: "flightScore.tags.fastest",
};

export const FlightScore = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "FlightScore");
  const priceDropDialogProps = useDialog();

  return (
    <Dialog {...priceDropDialogProps}>
      <DialogTrigger>
        <span className={cn("trigger-text")}>{t("flightScore.title")}</span>
      </DialogTrigger>

      <DialogContent title={t("flightScore.title")}>
        <div className={cn("container")}>
          {Object.entries(tagToDescription).map(([tag, description]) => (
            <div key={tag} className={cn("tag-content")}>
              <AlgomerchTags tags={[tag as AlgomerchTag]} />
              <span className={cn("description")}>{t(description)}</span>
            </div>
          ))}
        </div>

        <DialogClose className={cn("close-button")}>
          {t("close.button")}
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
